import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class EntityStatusService extends EntityService<IEntity> {
    constructor() {
        super(`/EntityStatuses`);
    }
}